import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../../shared/models/component-messages/diveAT/step3';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { DIVERS } from '../../../common/models/Typedivers';
import { AutoCompleteService } from '../../../../../shared/services/auto-complete.service';

@Component({
	selector: 'app-step3',
	templateUrl: './step3.component.html'
})
export class Step3Component implements OnInit {
	private LOG: LogService = new LogService(Step3Component);

	@Input() divers: DIVERS;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

	public optionsSelect: any[];
	public optionsSelectType = 'CLASSIFICATIONORGANISME';

	public step3 = new Step3();

	constructor(
		public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService, 
		private autoCompleteService: AutoCompleteService
	) { }

	ngOnInit(): void {
		this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
		const index = this.optionsSelect.indexOf(this.optionsSelect.find(option => option.libelle == 'Institution Européenne'));
		if (index >= 0) this.optionsSelect.splice(index, 1);
	}

	public getUid() {
		return this.uid;
	}
}
